import { render } from "./userManage.vue?vue&type=template&id=6bc81be8"
import script from "./userManage.vue?vue&type=script&lang=js"
export * from "./userManage.vue?vue&type=script&lang=js"

import "./userManage.vue?vue&type=style&index=0&id=6bc81be8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__